import { Entity } from "@/shared/state/visualization/schema/v1/three-d";

import styles from "./EntityConfig.module.css";
import { MeshConfig } from "./MeshConfig";
import { PathConfig } from "./PathConfig";
import { PositionConfig } from "./PositionConfig";
import { RotationConfig } from "./RotationConfig";
import { VectorFieldConfig } from "./VectorFieldConfig";

interface EntityConfigProps {
  entity: Entity;
  panelId: string;
  /** Whether a model may be authored here. See {@link MeshConfig}. */
  modelMeshEnabled: boolean;
}

export function EntityConfig({
  entity,
  panelId,
  modelMeshEnabled,
}: EntityConfigProps) {
  return (
    <>
      <div className={styles.spacer} />
      <PositionConfig entity={entity} panelId={panelId} />
      <div className={styles.spacer} />
      {/* Beside Position, because the two are the halves of one transform and
          compose together down the hierarchy. */}
      <RotationConfig entity={entity} panelId={panelId} />
      <div className={styles.spacer} />
      <MeshConfig
        entity={entity}
        panelId={panelId}
        modelMeshEnabled={modelMeshEnabled}
      />
      <div className={styles.spacer} />
      <PathConfig entity={entity} panelId={panelId} />
      <div className={styles.spacer} />
      <VectorFieldConfig entity={entity} panelId={panelId} />
    </>
  );
}
